export const ESI_PATIENT_CALENDAR_GET = 'esi-patient-calendar-get';
export const ESI_PATIENT_CALENDAR_GET_RESULT = ESI_PATIENT_CALENDAR_GET + '/result';
export const ESI_PATIENT_CALENDAR_GET_ERROR = ESI_PATIENT_CALENDAR_GET + '/error';
